import type { Borders } from "exceljs";

/** Standard thin border on all four sides — every data cell uses this. */
export const THIN_BORDER: Partial<Borders> = {
	top: { style: "thin" },
	left: { style: "thin" },
	bottom: { style: "thin" },
	right: { style: "thin" },
};

/** Light-grey fill for column-header cells. */
export const COLUMN_HEADER_FILL = {
	type: "pattern" as const,
	pattern: "solid" as const,
	fgColor: { argb: "FFD3D3D3" },
};

/** Pale-yellow fill for pending-change rows. */
export const PENDING_FILL = {
	type: "pattern" as const,
	pattern: "solid" as const,
	fgColor: { argb: "FFFFFFE0" },
};

/** Pale-red fill for pending-deletion rows. */
export const PENDING_DELETE_FILL = {
	type: "pattern" as const,
	pattern: "solid" as const,
	fgColor: { argb: "FFFFE0E0" },
};

/** White fill for section-header cells (overrides default no-fill). */
export const SECTION_HEADER_FILL = {
	type: "pattern" as const,
	pattern: "solid" as const,
	fgColor: { argb: "FFFFFFFF" },
};

/** Pale-grey fill for subheader rows ("PTO" etc.). */
export const SUBHEADER_FILL = {
	type: "pattern" as const,
	pattern: "solid" as const,
	fgColor: { argb: "FFF0F0F0" },
};
